module.exports = __webpack_public_path__ + "static/media/mobile-img-3.809f85de.png";